"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = void 0;
const React = require("react");
const FilterControl_1 = require("../../../../atoms/FilterControl");
/**
 * Renders a block header
 */
const Options = (_a) => {
    var { className = "" } = _a, rest = __rest(_a, ["className"]);
    return (React.createElement("div", { className: className, "data-test": "options" },
        React.createElement(FilterControl_1.FilterControl, Object.assign({}, rest))));
};
exports.Options = Options;
//# sourceMappingURL=index.js.map